import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a797f952&scoped=true&lang=pug"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=a797f952&prod&lang=sass&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=a797f952&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a797f952",
  null
  
)

export default component.exports